// const ExperienceCard = ({ company, logo, role, duration, location, highlights, link }) => {
//   return (
//     <div className="experience-card">
//       <div className="experience-card-header">
//         <img 
//             src={logo} 
//             alt={`${company} logo`} 
//             className="experience-logo" 
//             style={{
//             backgroundColor: link ? "#000" : "#fff" 
//         }} />
//         <div className="experience-header-details">
//           <h3 className="experience-role">{role}</h3>
//           <p className="experience-company">
//             {company} • {location}
//           </p>
//           <p className="experience-duration">{duration}</p>
//           {link && (
//             <a
//               href={link}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="experience-link"
//             >
//               Visit Site ↗
//             </a>
//           )}
//         </div>
//       </div>

//       <ul className="experience-highlights">
//         {highlights.map((point, index) => (
//           <li key={index}>{point}</li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default ExperienceCard;





import { useState } from "react";

const ExperienceCard = ({ company, logo, role, duration, location, highlights, link }) => {
  const [expanded, setExpanded] = useState(false);
  const isLong = highlights.length > 2;
  const visibleHighlights = expanded ? highlights : highlights.slice(0, 2);

  return (
    <div className="experience-card">
      <div className="experience-card-header">
        <img 
          src={logo} 
          alt={`${company} logo`} 
          className="experience-logo"
          style={{
            backgroundColor: link ? "#000" : "#fff"
          }} 
        />
        <div className="experience-header-details">
          <h3 className="experience-role">{role}</h3>
          <p className="experience-company">{company} • {location}</p>
          <p className="experience-duration">{duration}</p>
          {link && (
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="experience-link"
            >
              Visit Site ↗
            </a>
          )}
        </div>
      </div>

      <ul className="experience-highlights">
        {visibleHighlights.map((point, index) => (
          <li key={index}>{point}</li>
        ))}
      </ul>

      {isLong && (
        <button
          className="toggle-button"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "See less ▲" : "See more ▼"}
        </button>
      )}
    </div>
  );
};

export default ExperienceCard;
